import React from "react";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { util, config } from "../_helpers";
import { accountService } from "../_services";
import { gapi } from "gapi-script";
import { GoogleLogin } from "react-google-login";
import { toast } from "../_components/Toast";

function Login({ history, location }) {
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email is invalid").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const gLoginSuccess = (gData) => {
    console.log("google logged in success", gData);
    if (gData.profileObj) {
      onSubmit(
        { email: gData.profileObj.email, password: gData.tokenId },
        { setSubmitting: () => true }
      );
    }
  };

  const gLoginFailed = (err) => {
    console.log("google log in failed", err);
  };

  const initGoogleClient = () => {
    gapi.client.init({
      clientId: config.Google_Client_Id,
      scope: "",
    });
  };
  gapi.load("client:auth2", initGoogleClient);

  const redirectPostSuccess = (user) => {
    const { from } = location.state || { from: { pathname: "/" } };
    let redirectUrl = util.getParameterByName("redirect");
    redirectUrl
      ? (window.location.href = redirectUrl + "?token=" + user.token)
      : user.role.toUpperCase() == "SUPER-ADMIN"
      ? history.push("/admin/users")
      : history.push(`/profile/view/${user.id}`); 
  };

  function onSubmit({ email, password }, { setSubmitting }) {
    accountService
      .login(email.toLowerCase(), password)
      .then((res) => {
        redirectPostSuccess(res.user);
      })
      .catch((error) => {
        setSubmitting(false);
        toast.error(error);
      });
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <h5 className="card-header">Sign In</h5>
          
          <div className="form-group">
            <label>Email Address</label>
            <Field
              name="email"
              type="text"
              className={
                "form-control" +
                (errors.email && touched.email ? " is-invalid" : "")
              }
              placeholder="Email"
            />
            <ErrorMessage
              name="email"
              component="div"
              className="invalid-feedback"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <Field
              name="password"
              type="password"
              className={
                "form-control" +
                (errors.password && touched.password ? " is-invalid" : "")
              }
              placeholder="Password"
            />
            <ErrorMessage
              name="password"
              component="div"
              className="invalid-feedback"
            />
          </div>
          
          <div className="form-group">
            <button
              type="submit"
              disabled={isSubmitting}
              className="btn btn-primary"
            >
              {isSubmitting && (
                <span className="spinner-border spinner-border-sm mr-1"></span>
              )}
              Sign In
            </button>
          </div>

          <div className="form-group d-flex justify-content-between align-items-center mt-4">
            <Link to="forgot-password" size="sm" className="btn btn-link p-0">
              Forgot Password?
            </Link>
            {config.Google_Client_Id && <Link
              to={"register?redirect=" + util.getParameterByName("redirect")}
              className="btn btn-link p-0"
            >
              Sign Up Now
            </Link>}
          </div>

          {config.Google_Client_Id && (
            <div className="mt-4 pt-3 border-top border-secondary">
              <div style={{ textAlign: "center" }} className="form-group">
                <GoogleLogin
                  clientId={config.Google_Client_Id}
                  buttonText="CONTINUE WITH GOOGLE"
                  onSuccess={gLoginSuccess}
                  onFailure={gLoginFailed}
                  cookiePolicy={"single_host_origin"}
                  theme="dark"
                />
              </div>
            </div>
          )}

          <div style={{fontSize:"0.7em", color: "#666", textAlign:"center", marginTop:"30px"}}>
            <span>&#169;</span>{ new Date().getFullYear() + " " + config.Provider}. All Rights Reserved.
          </div>
        </Form>
      )}
    </Formik>
  );
}

export { Login };
